import React, {useContext, useMemo} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
//local
import {toSignContractId} from "constants/routes.const";
import {InitialsBadge} from "components/InitialsBadge";
import {SignContractsContext} from "../SignContractsContext";
import {Tag} from "components/Tag";
import {IconEyeCrossed} from "components/icons/index";
import {CustomTooltip} from "components/CustomTooltip";
import {
  signContractStatusColor,
  signContractStatusName,
  signContractsTabKeys,
  signContractsTabs,
} from "../constants";
import cn from "classnames";

const SignContractsItem = ({contract, ownUser}) => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const {signContractsActiveTab} = useContext(SignContractsContext);

  const isUnnamedContract = useMemo(
    () => !contract.name || contract.name === "SIGN_CONTRACT_UNNAMED_LABEL",
    [contract.name]
  );
  const name = useMemo(
    () => (isUnnamedContract ? t("SIGN_CONTRACT_UNNAMED_LABEL") : contract.name),
    [contract.name, isUnnamedContract, t]
  );
  const isBuyerSide = useMemo(
    () =>
      signContractsTabs.find(
        (tab) => tab.title === signContractsTabKeys.SIGN_CONTRACTS_BUYER_TAB
      ).id === signContractsActiveTab,
    [signContractsActiveTab]
  );
  const isHiddenContract = useMemo(
    () => isBuyerSide && contract.isHidden,
    [contract.isHidden, isBuyerSide]
  );

  return (
    <div
      className={cn("signing-contracts-table_item cpointer")}
      onClick={() => navigate(toSignContractId(contract.id))}
    >
      <div className="df-row-center">
        <InitialsBadge
          firstName={contract.createdMember?.User?.firstName}
          lastName={contract.createdMember?.User?.lastName}
          isCurrentUser={ownUser}
          addClass="mr-2"
        />
        <span className={isHiddenContract ? "discrete-text" : ""}>{name}</span>
        {isHiddenContract && (
          <CustomTooltip text="SIGN_CONTRACT_HIDED_TOGGLE_TOOLTIP">
            <div className="ml-2 df-row-center">
              <IconEyeCrossed addClass="mr-1" />
              <span className="fz-10 __bold __uppercase">
                {t("SIGN_CONTRACT_HIDDEN_LABEL")}
              </span>
            </div>
          </CustomTooltip>
        )}
      </div>
      <div className="signing-contracts-table_item__status">
        <Tag
          text={signContractStatusName[contract.status]}
          color={signContractStatusColor[contract.status]}
          noBackground
          uppercase
          bold
          addClass="fz-10 mr-0"
          needTranslation
        />
      </div>
    </div>
  );
};

export default SignContractsItem;
